module.exports = __webpack_public_path__ + "img/cougar.6250285.png";